import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "@/App.css";
import Opener from './components/Opener';
import Dashboard from './components/Dashboard';
import LandingPage from './pages/LandingPage';

function AppShell() {
  const [openerDone, setOpenerDone] = useState(false);
  return (
    <>
      {!openerDone && <Opener onComplete={() => setOpenerDone(true)} />}
      {openerDone && <Dashboard />}
    </>
  );
}

function App() {
  React.useEffect(() => {
    // Remove Emergent badge (also re-runs in case the script re-injects it)
    const remove = () => {
      const b = document.getElementById('emergent-badge');
      if (b) b.remove();
    };
    remove();
    const id = setInterval(remove, 500);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/uygulama" element={<AppShell />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
